import React from "react";
import { Link } from "react-router-dom";
import useLangPath from "@/hooks/useLangPath";

/**
 * A Link that automatically prepends the current language prefix
 * to internal paths. External URLs (http/https/mailto/tel) or hash-only
 * anchors are passed through unchanged.
 */
const LocalizedLink = React.forwardRef(({ to, ...rest }, ref) => {
  const { buildPath } = useLangPath();

  const isExternal =
    typeof to === "string" &&
    (/^(https?:|mailto:|tel:)/i.test(to));

  const finalTo = isExternal ? to : buildPath(to);

  return <Link ref={ref} to={finalTo} {...rest} />;
});
LocalizedLink.displayName = "LocalizedLink";

export default LocalizedLink;
